import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ImageLoading from "../../components/ImageLoading";

import IconDownloadButton from "../../components/IconDownloadButton";
import DematTable from "./DematTable";
import { sideBarContext } from "../../App";

function EligibleUsersView() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [imageLoading, setImageLoading] = useState(false);
  const [holdingsOption, setholdingsOption] = useState("demat");
  const [userNumber, setUserNumber] = useState("");

  function capitalize(str) {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  }

  function formatString(str) {
    if (!str) return "";
    return str
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  const filterOptions = [
    { value: "demat", label: "Demat Holdings" },
    { value: "unapproved", label: "Unapproved Holdings" },
    { value: "credit", label: "Credit Limit Holdings" },
  ];
  const { expanded } = useContext(sideBarContext);

  return (
    <div
      className={`${
        expanded ? "w-[calc(100%-240px)]" : "w-[calc(100%-90px)]"
      } bg-[#f1f1f6] min-h-[100vh] max-h-full px-[16px] pt-[16px]`}
    >
      <div className=" w-full bg-white h-[57px] rounded-lg p-4">
        <p className=" text-xl font-semibold">Eligible Users</p>
      </div>
      {imageLoading && (
        <div className="w-full bg-white  mt-4 rounded-lg  h-[370px] flex items-center justify-center">
          <ImageLoading />
        </div>
      )}
      {!imageLoading && (
        <div className=" w-full bg-white px-4 mt-4 pt-[28px] rounded-lg pb-4 mb-4">
          <p className=" text-sm">
            <span
              className="cursor-pointer hover:underline hover:font-medium transition ease-in-out duration-500"
              onClick={() => navigate(-1)}
            >
              {" "}
              List of Users{" "}
            </span>
            <span className=" font-bold text-base text-[#262626]">
              {" "}
              &gt; {userNumber || "---"}
            </span>
          </p>
          <div className="mt-4 h-[1px] w-full border border-solid border-[#F4F4F4]"></div>
          <div className="flex flex-row justify-between items-center mt-4">
            <div className="flex justify-between items-center rounded-lg w-fit bg-[#F4F4F4] py-0.5 px-0.5 h-[32px]">
              {filterOptions.map((option) => (
                <button
                  className={`text-xs font-bold m-0.5 px-4 py-1 text-[#262626] ${
                    holdingsOption === option.value ? "bg-white rounded" : ""
                  }`}
                  onClick={() => setholdingsOption(option.value)}
                >
                  {option.label}
                </button>
              ))}
            </div>

            {/* <button>
              {" "}
              <IconDownloadButton bg="bg-[#00394d]" iconColor={"text-white"} />
            </button> */}
          </div>
          <DematTable
            filter={holdingsOption}
            id={id}
            setUserNumber={setUserNumber}
          />
        </div>
      )}
    </div>
  );
}

export default EligibleUsersView;
